import { TrackingPrice } from '../../../types/tracking-price'
import { DataLayerProductGA4 } from '../helpers/clientState'

export const trackBasket = (
  cartItems: DataLayerProductGA4[],
  total: TrackingPrice,
) => {
  const event = {
    event: 'cart',
    basket: cartItems,
    total_campaign_reduction_with_tax: total.campaignReductionWithTax,
    total_sale_reduction_with_tax: total.saleReductionWithTax,
    total_with_tax: total.withTax,
    total_without_tax: total.withoutTax,
  }

  return event
}
